module.exports = __webpack_public_path__ + "static/canoeTrip-bd3808bd9567974bc0acfc9a258e05a4.jpg";